import React, { useState } from "react"
import Navbar from "../components/Navbar"
import News from "../components/News"
import Footer from "../components/Footer"
import Products from "../components/Products"
import {
  Container,
  Title,
  FilterContainer,
  Filter,
  FilterText,
  Select,
  Option,
} from "../styles/ProductListStyle"
import { useLocation } from "react-router-dom"

const ProductList = () => {
  const location = useLocation()
  const cat = location.pathname.split("/")[2]
  const [sort, setSort] = useState("newest")

  return (
    <Container>
      <News />
      <Navbar />
      <Title>Products</Title>
      <FilterContainer>
        <Filter>
          <FilterText>Sort Products</FilterText>
          <Select onChange={(e) => setSort(e.target.value)}>
            <Option value='newest'>Newest</Option>
            <Option value='asc'>Price (asc)</Option>
            <Option value='desc'>Price (desc)</Option>
          </Select>
        </Filter>
      </FilterContainer>
      <Products cat={cat} sort={sort} />
      <Footer />
    </Container>
  )
}

export default ProductList
